const escapeHtml = (value = '') =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const applyInlineMarkdown = (value = '') => {
  let text = escapeHtml(value);
  text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/\*(.+?)\*/g, '<em>$1</em>');
  text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
  text = text.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
  return text;
};

const flushList = (buffer, listType, html) => {
  if (!buffer.length) {
    return;
  }
  html.push(`<${listType}>${buffer.join('')}</${listType}>`);
  buffer.length = 0;
};

export default function markdownToHtml(markdown = '') {
  const lines = markdown.split(/\r?\n/);
  const html = [];
  const listBuffer = [];
  let currentListType = null;

  const closeList = () => {
    if (currentListType) {
      flushList(listBuffer, currentListType, html);
      currentListType = null;
    }
  };

  lines.forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed) {
      closeList();
      return;
    }

    const headingMatch = trimmed.match(/^(#{1,3})\s+(.*)/);
    if (headingMatch) {
      closeList();
      const level = headingMatch[1].length + 1; // start at h2 for better typographic rhythm
      const safeLevel = Math.min(level, 4);
      html.push(`<h${safeLevel}>${applyInlineMarkdown(headingMatch[2])}</h${safeLevel}>`);
      return;
    }

    if (/^>\s+/.test(trimmed)) {
      closeList();
      const text = trimmed.replace(/^>\s+/, '');
      html.push(`<blockquote>${applyInlineMarkdown(text)}</blockquote>`);
      return;
    }

    if (/^[-*]\s+/.test(trimmed)) {
      const text = trimmed.replace(/^[-*]\s+/, '');
      if (currentListType && currentListType !== 'ul') {
        closeList();
      }
      currentListType = 'ul';
      listBuffer.push(`<li>${applyInlineMarkdown(text)}</li>`);
      return;
    }

    if (/^\d+\.\s+/.test(trimmed)) {
      const text = trimmed.replace(/^\d+\.\s+/, '');
      if (currentListType && currentListType !== 'ol') {
        closeList();
      }
      currentListType = 'ol';
      listBuffer.push(`<li>${applyInlineMarkdown(text)}</li>`);
      return;
    }

    closeList();
    html.push(`<p>${applyInlineMarkdown(trimmed)}</p>`);
  });

  closeList();
  return html.join('');
}
